import {
  SequenceMenu,
  TextInputField,
  InputSelectControlField,
  RadioButtonGroupField,
  Center,
  Box,
  Flex
} from '@sequencehq/core-components'
import { GreyGrey70, Primary13SemiBold } from '@sequencehq/core-components'
import { FixedTierTableInput } from '../common/inputs/FixedTierTableInput/FixedTierTableInput'
import { PercentageTierTableInput } from '../common/inputs/PercentageTierTableInput/PercentageTierTableInput'
import { PercentageTierWithLimitsTableInput } from '../common/inputs/PercentageTierWithLimitsTableInput/PercentageTierWithLimitsTableInput'
import { useVolumePriceForm } from './useVolumePriceForm'
import { PricingModelField } from '../common/PricingModelField'
import { Currency } from '@sequencehq/api'
import { UsageTierType } from 'common/drawers/PricingEditor/domain'
import { UsageMetricParameterFields } from '../common/UsageMetrics/UsageMetricParameterFields'
import { kebabMenuItems } from './volumePrice.utils'
import { ExternalLedgerForm } from '../common/ExternalLedgerForm/ExternalLedgerForm'
import { BillingFrequencyField } from '../common/BillingFrequencyField'
import { ProductSelectField } from '../common/ProductSelectField'
import { CopyPricingTableButton } from '../common/CopyPricingTableButton'
import { UsageMetricSelect } from 'UsageMetrics/index'

export const VolumePriceForm = () => {
  const { fieldsConfig, currency } = useVolumePriceForm()

  return (
    <>
      <Flex direction="column" gap="16px">
        <ProductSelectField />

        <PricingModelField />

        <TextInputField
          label="Display name (appears on invoice)"
          data-testid="volume.name"
          value={fieldsConfig.name.value}
          onChange={e => fieldsConfig.name.onChange(e.target.value)}
          validationErrors={fieldsConfig.name.validationErrors}
          isDisabled={fieldsConfig.name.disabled}
          placeholder="Enter a display name"
        />

        <BillingFrequencyField
          data-testid="volume.billingFrequency"
          value={fieldsConfig.billingFrequency.value}
          options={fieldsConfig.billingFrequency.options}
          onChange={fieldsConfig.billingFrequency.onChange}
          validationErrors={fieldsConfig.billingFrequency.validationErrors}
          isDisabled={fieldsConfig.billingFrequency.disabled}
        />

        <UsageMetricSelect
          data-testid="volume.usageMetric"
          validationErrors={fieldsConfig.usageMetricId.validationErrors}
          value={fieldsConfig.usageMetricId.value}
          onChange={fieldsConfig.usageMetricId.onChange}
          isDisabled={fieldsConfig.usageMetricId.disabled}
        />
        <UsageMetricParameterFields
          fieldsConfig={fieldsConfig}
          usageMetricId={fieldsConfig.usageMetricId.value}
        ></UsageMetricParameterFields>
        <RadioButtonGroupField
          label="Type"
          value={fieldsConfig.usageTierType.value}
          options={fieldsConfig.usageTierType.options}
          onChange={newValue =>
            fieldsConfig.usageTierType.onChange(newValue as UsageTierType)
          }
          validationErrors={fieldsConfig.usageTierType.validationErrors}
          isDisabled={fieldsConfig.usageTierType.disabled}
          data-testid="volume.usageTierType"
          fullWidth
        />
        <Box width="100%">
          <Flex gap={4} alignItems="center" marginBottom="8px">
            <Box {...Primary13SemiBold} color={GreyGrey70}>
              Tiers
            </Box>
            {!fieldsConfig.currency.hidden && (
              <InputSelectControlField
                data-testid="volume.currency"
                value={fieldsConfig.currency.value}
                onChange={newCurrency =>
                  fieldsConfig.currency.onChange(newCurrency as Currency)
                }
                options={fieldsConfig.currency.options}
                validationErrors={fieldsConfig.currency.validationErrors}
                disabled={fieldsConfig.currency.disabled}
                placeholder="Select currency"
                width="90px"
              />
            )}
            <Flex grow="1"></Flex>
            {fieldsConfig.usageTierType.value === 'PERCENTAGE' ? (
              <Center height="14px">
                <SequenceMenu
                  variant="ghost"
                  buttonSize="small"
                  alignment="bottom-right"
                  items={kebabMenuItems({
                    includePercentageLimits:
                      fieldsConfig.includePercentageLimits.value,
                    onChange: fieldsConfig.includePercentageLimits.onChange,
                    percentageTiers: fieldsConfig.percentageTiers.value,
                    currency
                  })}
                  data-testid="volume.percentageTier.kebabMenu"
                />
              </Center>
            ) : (
              <CopyPricingTableButton
                data={{ tiers: fieldsConfig.tiers.value, currency }}
                data-testid="volume.fixedTier.copyPricingTable"
              />
            )}
          </Flex>
          {fieldsConfig.usageTierType.value === 'FIXED' ? (
            <FixedTierTableInput
              value={fieldsConfig.tiers.value}
              onChange={fieldsConfig.tiers.onChange}
              isDisabled={fieldsConfig.tiers.disabled}
              currency={currency}
              validationErrors={fieldsConfig.tiers.validationErrors}
            />
          ) : fieldsConfig.includePercentageLimits.value ? (
            <PercentageTierWithLimitsTableInput
              value={fieldsConfig.percentageTiers.value}
              onChange={fieldsConfig.percentageTiers.onChange}
              isDisabled={fieldsConfig.percentageTiers.disabled}
              currency={currency}
              validationErrors={fieldsConfig.percentageTiers.validationErrors}
            />
          ) : (
            <PercentageTierTableInput
              value={fieldsConfig.percentageTiers.value}
              onChange={fieldsConfig.percentageTiers.onChange}
              isDisabled={fieldsConfig.percentageTiers.disabled}
              currency={currency}
              validationErrors={fieldsConfig.percentageTiers.validationErrors}
            />
          )}
        </Box>

        <ExternalLedgerForm />
      </Flex>
    </>
  )
}
